import UserActionError from '@/interfaces/errors/userAction';
import { spreadsheet as spreadsheetCore } from '@industriousapps/excelkits-core';
const PREFIX = 'utils: spreadsheets: parseErrors:';
const {
  ERROR_CODES: CORE_ERROR_CODES
} = spreadsheetCore;
export const CODES = {
  themeParse: `${PREFIX}ThemeParse`,
  noStylesFound: `${PREFIX}NoStylesFound`
};
const USER_MESSAGES = {
  themeParse: 'We encountered some issues importing theme colors, you may encounter colorization issues',
  noStylesFound: 'No styles were found, please ensure you\'re uploading a ".xlsx" file'
}; // Create theme parsing error/warning

export const createThemeParsingError = (prefix, err) => {
  const actionErr = new UserActionError(`${prefix} failed to parse ExcelJs theme: ${err}`, err);
  actionErr.userMessage = USER_MESSAGES.themeParse;
  actionErr.code = CODES.themeParse;
  return actionErr;
}; // No styles found for during parsing

export const createNoStylesFoundError = prefix => {
  const actionErr = new UserActionError(`${prefix} no styles found`);
  actionErr.userMessage = USER_MESSAGES.noStylesFound;
  actionErr.code = CODES.noStylesFound;
  return actionErr;
}; // Covert core errors into user errors

export const coreErrorToUserError = (prefix, err) => {
  // @ts-ignore
  if (err.code === CORE_ERROR_CODES.themeParse) {
    return createThemeParsingError(prefix, err);
  } else {
    return createNoStylesFoundError(prefix);
  }
};
export default {
  coreErrorToUserError,
  createThemeParsingError,
  createNoStylesFoundError
};